<template>
  <div class="right-body" id="addClouds">
    <div class="all-drives">
      <div class="right-cont-middle">
        <div class="right-cont-middle-position">
          <span class="connect-desc">{{$t('language.addCloud.connectDesc')}}</span>
          <div class="icon order sort" :class="[rightBoShow?'':'order-click']" @click="cloudOrderSort"></div>
        </div>
      </div>
      <div class="right-cont-body">
        <div  :class="[rightBoShow?'cont-box':'cont-box-order']">
          <div class="drive-add-clouds-up" :class="{'up-clouds-none':!addCloudLineUp ||!addCloudLineUp.length}" v-if="rightBoShow">
            <div class="add-txt">{{$t('language.addCloud.peCloud')}}</div>
            <div class="drive-add-cloud-top">
            <!-- Lite云盘 -->
            <div v-show="$store.state.isLiteMode && !isBusinessCloud(cloud)" class="lite_cloud" v-for="cloud in clouds" :key="cloud" @click="readyAddDrive(cloud)">
                <div :class="'drive-icon-' + cloud"></div>
                <span>{{ cloud }}</span>
            </div>
            <div v-show="!$store.state.isLiteMode" class="drive-add-cloud" :key="index" v-for="(item,index) in addCloudLineUp" @click="addCloudDialog(item)" :style="{height:getAddCloudHeight()+'Px'}"
            v-if="item.appName.indexOf('_v2')==-1 && item.appName != 'oneDrive' && item.appName != 'googlePhotos'">
            <!-- 上面的v-if是不显示新增的那几个v2云盘 -->
              <div class="add-cloud-item" v-if='item.appName'>
                <div class='add-cloud-center'>
                <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="drive-add-clouds-down" v-if="rightBoShow" >
               <div class="add-txt">{{$t('language.addCloud.buCloud')}}</div>
            <!-- Lite云盘 -->
            <div v-show="$store.state.isLiteMode && isBusinessCloud(cloud)" class="lite_cloud" v-for="cloud in clouds" :key="cloud" @click="readyAddDrive(cloud)">
                <div :class="'drive-icon-' + cloud"></div>
                <span>{{ cloud }}</span>
            </div>
            <div v-show="!$store.state.isLiteMode" class="drive-add-cloud" :key="index" v-for="(item,index) in addCloudLineDown" @click="addCloudDialog(item)" :style="{height:getAddCloudHeight()+'Px'}">
              <div class="add-cloud-item" v-if='item.appName'>
                <div class='add-cloud-center'>
                <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="drive-add-clouds-order" v-if="!rightBoShow">
            <!-- Lite云盘 -->
            <div v-show="$store.state.isLiteMode" class="lite_cloud" v-for="cloud in sortedClouds" :key="cloud" @click="readyAddDrive(cloud)">
                <div :class="'drive-icon-' + cloud"></div>
                <span>{{ cloud }}</span>
            </div>
            <div v-show="!$store.state.isLiteMode" class="drive-add-cloud-order" v-if="item.appName.indexOf('_v2')==-1 && item.appName != 'oneDrive'" :key="index" v-for="(item,index) in reorder" @click="addCloudDialog(item)" :style="{height:getAddCloudHeight()+'Px'}">
              <div class="add-cloud-item" v-if='item.appName'>
                <div class='add-cloud-center'>
                <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="selectInfo-footer">
          <div class="icon scaling-open scaling-open-position" v-show="snapTaskIconShow" @click="snapTasksOpen()">
            <snapTaskDialog ref="snapTaskDialog" @cancel='cancelUpload($event)'></snapTaskDialog>
          </div>
        </div>
      </div>
      <addCloudDialog ref="addCloudDialog"></addCloudDialog>
      <addFtpDialog ref="addFtpDialog"></addFtpDialog>
      <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
      <retryFailedDialog ref="retryFailedDialog"></retryFailedDialog>
      <cancelAllDialog ref="cancelAllDialog"></cancelAllDialog>
      <addNasDialog ref="addNasDialog"></addNasDialog>
      <addSpecialDialog ref="addSpecialDialog"></addSpecialDialog>
      <appleTipsDialog ref="appleTipsDialog"></appleTipsDialog>
      <appleICloudDriveDiaLog ref="appleICloudDriveDiaLog"></appleICloudDriveDiaLog>
      <!-- 添加云盘对话框 -->
      <liteAddDrive :auth="auth" @submit="addCloud()" />
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import commonstate from '@/js/constant.js';
import addCloudDialog from '@/components/popup/add_cloud_popups/add_cloud_popup';
import addFtpDialog from '@/components/popup/add_cloud_popups/add_ftp_popup';
import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
import snapTaskDialog from "@/components/popup/cloud_exploer_popups/snap_task_popup";
import commonUtils from "@/js/workspace/common_util.js";
import retryFailedDialog from "@/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup";
import cancelAllDialog from '@/components/popup/cloud_exploer_popups/cancel_all_popup.vue';
import addNasDialog from '@/components/popup/add_cloud_popups/add_nas_popup';
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import addSpecialDialog from '@/components/popup/add_cloud_popups/add_special_cloud_popup';
import appleTipsDialog from '@/components/popup/add_cloud_popups/apple_tips_popup';
import appleICloudDriveDiaLog from '@/components/popup/add_cloud_popups/apple_iclouddrive_tips_popup';
import liteAddDrive from "@/components/workspace/lite_add_drive";
function sortDown (x, y) {
  return y.level - x.level;
}
export default {
  components: {
    addFtpDialog,
    addCloudDialog,
    snapTaskDialog,
    detailedProgrssDialog,
    retryFailedDialog,
    cancelAllDialog,
    addNasDialog,
    addSpecialDialog,
    appleTipsDialog,
    appleICloudDriveDiaLog,
    liteAddDrive,
  },
  inject: ["reload"],
  data: function () {
    return {
      rightBoShow: true,
      addCloudLineUp: [],
      addCloudLineDown: [],
      allCategories: [],
      allDrivesFlag: -1,
      drives: '',
      unavailCloud: ['facebook', 'goDaddy', 'copy', 'team', 'picasa', 'ubuntu', 'youtube', 'bitcasa','apple'],
      snapTaskIconShow: false,
      retryItems: [],
      upHeight:329,
      downHeight:209,
      directlyAddCloud:['google_drive','google_drive_sharedWithMe','gSuiteSharedDrive','dropbox','oneDrive','oneDriveV2','box','boxBusiness','pCloud','dropbox4Business','oneDrive4Business','sharePointOnline','4shared'],
      reName:null,
      // 添加云盘窗口
      liteAddDriveWin: null,
      // 支持的云盘类型
      clouds: [
          "GoogleWorkspace",
          "GoogleDrive",
          "OneDrive",
          "Dropbox",
          "FTP",
          "SFTP",
          "Box",
          "PCloud",
          "MediaFire",
          "WebDAV",
      ],
      // 添加云盘参数
      auth: {
          show: false,
          loading: false,
          type: "",
          name: "",
          ftp: {
              protocol: "ftp-plain",
              host: "",
              port: 21,
              username: "",
              password: "",
              passive: true,
              encoding: "UTF-8",
              path: "",
          },
          sftp: {
              host: "",
              port: 22,
              username: "",
              password: "",
              privateKey: "",
              passphrase: "",
              path: "",
          },
          webdav: {
              url: "",
              username: "",
              password: "",
          },
          mediafire: {
              email: "",
              password: "",
          },
      },
    };
  },
  beforeDestroy() {
      // 清除添加云盘检测
      if (this.liteAddDriveTimer) {
          clearInterval(this.liteAddDriveTimer);
          this.liteAddDriveTimer = null;
      }
      // 关闭添加云盘窗口
      if (this.liteAddDriveWin && !this.liteAddDriveWin.closed) {
          this.liteAddDriveWin.close();
      }
  },
  mounted () {

    window.addEventListener('message', this.addCloudCallBack);
    let that = this;
    var getter = this.$store.getters;
    if (getter && this.$store.state.allCategories && this.$store.state.allCategories.length &&this.$store.state.addCloudLineUp&&this.$store.state.addCloudLineDown) {
      this.addCloudLineUp = this.$store.state.addCloudLineUp;
      this.addCloudLineDown = this.$store.state.addCloudLineDown;
      this.allCategories = this.$store.state.allCategories;
    } else {
      this.groupCategories();
    }
    //   this.$nextTick(()=>{
    //           window.addEventListener('resize', () => { //监听浏览器窗口大小改变
    //                    //浏览器变化执行动作
    //                   this.$nextTick(()=>{
    //                 //that.getAllHeight();//监听窗口变化，给高度
    //                 that.$forceUpdate()
    //                   });
    //           });
    //  // that.getAllHeight();//界面加载时给高度
    //       });
    //禁用拖拽功能
    commonUtils.dragDisAble('addClouds',this);
    //初始化临时任务数据
    commonUtils.mountedDetailData(that);

    var getData = commonUtils.getQueryJSON();
    // console.log(getData)
    if(getData&&getData.source=="ext"){
      this.$nextTick(function () {
        that.$toast({
            text: "After adding the cloud successfully, you can go back to SAVE TO CLOUD extension to check it.",
            type: 'notice',
            idValue: "addClouds",
            duration: 3000
        });
      })
    }
  },
  watch: {
    '$store.state.haveNewSnapData': function (newValue, oldValue) {
      let that = this;
      //触发事件后，判断是否获取进度
      if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度
        commonUtils.runDetailProgressData(that);
      }
    },
    //监听缓存中右侧待执行临时任务列表数据
    '$store.state.retryItems': function () {
      this.$refs.snapTaskDialog.items = Object.assign([], this.$store.state.retryItems);
      if (this.$store.state.retryItems.length > 200) {
        this.$store.state.retryItems.splice(201, this.$store.state.retryItems.length + 1);
        this.$toast({
          text: this.$t('language.cloudExploer.simultaneous'),
          type: 'fail',
          idValue: "rightBo"
        });
      }
      this.retryItems = this.$refs.snapTaskDialog.items;
    },
     //监听右侧待执行临时任务列表+上传列表总和数据
    retryItems: function (newValue, oldValue) {
      let that = this;
      if (!newValue.length) {
        this.$store.commit("setSourceItems", []);
        this.selectItemArr = [];
      }
      //任务执行列表执行操作，包括刷新后界面仍有任务
      if (oldValue.length == 0) {
        this.$nextTick(function () {
          if (that.$store.state.loadFlag) {
            commonUtils.runDetailProgressData(that);
            that.$store.state.loadFlag = false;
          }
        });
      }
    },
    //监听临时任务并根据状态将数据放在不同的tab页面
    '$store.state.detailedProgrssData': function (newValue, oldValue) {
      this.$refs.detailedProgrss.$refs.tab1.taskDatas = newValue;
    },
    //监听云盘数据，将其进行分类
    '$store.state.cloudCategories': function (newValue, oldValue) {
      if (newValue.length) {
        commonstate.cloudCategories = newValue;
        this.groupCategories();
        //this.getAllHeight();//监听如果有分类数据后给高度
      }
    },
     //监听上传列表数据
    '$store.state.uploadArr': function (newVale, oldValue) {
      let snapData = Object.assign([], this.$store.state.retryItems);
      let uploadArr = Object.assign([], this.$store.state.uploadArr);
      this.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
    },
  },
  onDrag: function (e) {
    e.stopPropagation();
    e.preventDefault();
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'login') {
      next((vm) => {
        let ud = commonUtils.getUser().id;
        vm.Utils.doDrivesRequest("list", {
          ud: ud
        }).then(result => {
            if (result.status == 200) {
              if (result.drives.length > 0) {
                vm.allDrivesFlag = true;
              } else {
                vm.allDrivesFlag = false;
              }
            } else {
              if(result.reason){
              vm.$toast({
                text: vm.$t('language.exception.' + result.reason),
                type: 'fail',
                idValue: "allBox"
              });
              }else{
                   vm.Utils.doDrivesRequest("list", {
                    ud: ud
                   }).then(result => {
                         if (result.status == 200) {
                         if (result.drives.length > 0) {
                             vm.allDrivesFlag = true;
                        } else {
                             vm.allDrivesFlag = false;
                        }
                      }
                   });
              }
            }
          })
      });
    } else {
      next((vm) => {
        vm.allDrivesFlag = true;
      });
    }
  },
  methods: {
    // 发送Lite请求
    sendRequest(path, data, callback, errCallback) {
        const noLoadingPaths = ["/task/progress"];
        if (noLoadingPaths.indexOf(path) == -1) {
            this.fullscreenLoading = true;
        }
        requestUtils.doLiteRequest(path, data)
            .then(res => {
                if (noLoadingPaths.indexOf(path) == -1) {
                    this.fullscreenLoading = false;
                }
                let code = res.code
                let msg = res.msg
                if (msg == undefined) {
                    msg = res.message;
                }
                if (code == 200) {
                    // 请求成功
                    if (callback) {
                        callback(res.data);
                    }
                } else if (code == 400) {
                    // 请求失败
                    Message.warning(msg);
                    if (errCallback) {
                        errCallback()
                    }
                } else {
                    if (msg == "Unauthorized") {
                        // 未登录
                        location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                    } else {
                        // 服务器异常
                        Message.error(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    }
                }
            }, err => {
                if (noLoadingPaths.indexOf(path) == -1) {
                    this.fullscreenLoading = false;
                }
                // 请求异常
                Message.error(err);
                if (errCallback) {
                    errCallback()
                }
            });
    },
    // 展开云盘根目录
    openDrive(id) {
        this.$store.state.curDriveId = id;
        this.$store.state.curNode = null;
        this.$store.state.curStart = null;
        this.$store.state.needLoad = Math.random() + "";
        this.$store.commit('setleftbannerMenuClick', 108);
        this.$router.push('/mc_project/lite_file');
    },
    // 仅加载云盘数据
    onlyLoadDrives(callback) {
        this.sendRequest("/drive/list", {}, (data) => {
            callback(data);
        });
    },
    // 加载云盘
    loadDrives(callback) {
        this.sendRequest("/drive/list", {}, (data) => {
            this.$store.state.drives = data;
            if (callback) {
                callback();
            }
        })
    },
    // 添加云盘
    addCloud() {
        if (this.auth.loading) return;
        this.auth.loading = true;
        this.sendRequest("/drive/auth", this.auth, (data) => {
            this.auth.loading = false;
            this.auth.show = false;
            if (data.type == "url") {
                // 清除添加云盘检测
                if (this.liteAddDriveTimer) {
                    clearInterval(this.liteAddDriveTimer);
                    this.liteAddDriveTimer = null;
                }
                // 关闭添加云盘窗口
                if (this.liteAddDriveWin && !this.liteAddDriveWin.closed) {
                    this.liteAddDriveWin.close();
                }
                // 指定宽高和居中窗口
                const width = 600;
                const height = 600;
                const left = (window.screen.width - width) / 2;
                const top = (window.screen.height - height) / 2;
                // 打开小窗口
                this.liteAddDriveWin = window.open(data.data, "_blank", `width=${width},height=${height},left=${left},top=${top}`);
                // 开启添加云盘检测
                this.liteAddDriveTimer = setInterval(() => {
                    // 如果窗口已经关闭
                    if (this.liteAddDriveWin.closed) {
                      // 则停止检测
                      if (this.liteAddDriveTimer) {
                          clearInterval(this.liteAddDriveTimer);
                          this.liteAddDriveTimer = null;
                      }
                    }
                    // 检测是否添加成功
                    this.onlyLoadDrives((data) => {
                      // 比对新旧数据
                      const oldDrives = this.$store.state.drives;
                      // 取出旧数据
                      let ids_times = [];
                      for (let i = 0; i < oldDrives.length; i++) {
                        ids_times.push(oldDrives[i].id + oldDrives[i].ctime);
                      }
                      // 遍历新数据
                      for (let i = 0; i < data.length; i++) {
                        // 找到旧数据不存在的云盘
                        if (ids_times.indexOf(data[i].id + data[i].ctime) == -1) {
                          // 替换所有旧数据
                          this.$store.state.drives = data;
                          // 打开这个云盘
                          this.openDrive(data[i].id);
                          // 关闭添加云盘窗口
                          if (this.liteAddDriveWin && !this.liteAddDriveWin.closed) {
                              this.liteAddDriveWin.close();
                          }
                          break;
                        }
                      }
                    });
                }, 1000);
            } else {
                // 已经成功，重新加载
                this.loadDrives(() => {
                    // 并且打开
                    this.openDrive(data.data.id);
                });
            }
        }, () => {
          this.auth.loading = false;
        });
    },
    isBusinessCloud(cloud) {
      return cloud=='GoogleWorkspace';
    },
    // 准备添加云盘
    readyAddDrive(cloud) {
        this.auth.type = cloud;
        this.auth.name = this.addCloudNameInit(cloud);
        this.auth.loading = false;
        this.auth.show = true;
    },
    // 添加云盘名称初始化
    addCloudNameInit(cloud) {
        let name = cloud;
        if (cloud == 'GoogleWorkspace') {
          name = 'Google Workspace';
        } else if (cloud == 'GoogleDrive') {
          name = 'Google Drive';
        } else if (cloud == 'OneDrive') {
          name = 'OneDrive';
        } else if (cloud == 'Dropbox') {
          name = 'Dropbox';
        } else if (cloud == 'FTP') {
          name = 'FTP';
        } else if (cloud == 'SFTP') {
          name = 'SFTP';
        } else if (cloud == 'Box') {
          name = 'Box';
        } else if (cloud == 'PCloud') {
          name = 'pCloud';
        } else if (cloud == 'MediaFire') {
          name = 'MediaFire';
        }
        let names = [];
        for (let i = 0; i < this.$store.state.drives.length; i++) {
          names.push(this.$store.state.drives[i].name);
        }
        // 返回一个不重复的名称，如果有同名就添加数字
        let count = 1;
        let temp = name;
        while (names.indexOf(temp) != -1) {
          temp = name + " " + count;
          count++;
        }
        return temp;
    },
    addCloudCallBack(result){
         let ud=commonUtils.getUser().id;
         var length= localStorage.getItem(ud+'driveNum');//用户的云盘列表长度
         if(length){
             localStorage.setItem(ud+'noticeShow',true);
         }
         // localStorage.removeItem(ud+'driveNum');
    },
    getAllHeight(){//获取横线上下的高度
        let numHeight;
        let allHeight;
        let that=this;
        let upData=that.$store.getters.getAddCloudLineUp;
        let downData=that.$store.getters.getAddCloudLineDown;
        this.$nextTick(()=>{
         numHeight=this.getAddCloudHeight();//得到每一个的高度
         let upHeight=Math.ceil((upData.length)/8)*(parseInt(numHeight)+5);//计算上面的高度
         if(upHeight){
             that.upHeight=upHeight-4;
         }
         let downHeight=Math.ceil((downData.length)/8)*(parseInt(numHeight)-2);//计算下面的高度
         if(downHeight){
             that.downHeight=downHeight-4;
         }
        });
    },
    getAddCloudHeight(){
      let arr;
      let width;
     let height;
      if(document.getElementsByClassName('drive-add-clouds-up').length){
       arr=document.getElementsByClassName('drive-add-clouds-up');
      }else{
       arr=document.getElementsByClassName('drive-add-clouds-order');
      }
      if(arr.length&&arr[0].clientWidth){
       width=arr[0].clientWidth*0.119;
       height=parseInt(width*0.6);//每一个高度等于宽度乘以0.72
      }
        return height;
    },
    groupCategories () {
      let that = this;
      //获取云盘种类并存储在store中
      let addCloudLineUp = [];
      let addCloudLineDown = [];
      let allCategories = [];
      let CategoriesAll = commonstate.cloudCategories;
      let jsonTargetUp = [];
      let jsonTargetDown = [];
      for(var i=0;i<CategoriesAll.length;i++){
          var item = CategoriesAll[i];
            if (!item.bussiness) {
                  if (!that.unavailCloud.includes(item.appName) && !commonstate.emailClouds.includes(item.appName) && item.appName != 'amazon') {
                     jsonTargetUp.push(item);
                  }
        } else  {
            jsonTargetDown.push(item);
        }
      }
      this.addCloudLineUp = jsonTargetUp.sort(sortDown);
      this.addCloudLineDown = jsonTargetDown.sort(sortDown);
      allCategories = this.addCloudLineUp.concat(this.addCloudLineDown);
       this.allCategories = allCategories;
      this.$store.commit('setAddCloudLineUp', this.jsonTargetUp);
      this.$store.commit('setAddCloudLineDown', this.jsonTargetDown);
      this.$store.commit('setAllCategories', this.addCloudLineUp.concat(this.addCloudLineDown));
    },
    snapTasksOpen () {//打开添加云盘的临时任务弹窗
      this.$store.state.snapTaskShow = !this.$store.state.snapTaskShow;
    },
    cloudOrderSort () {//切换到按字母排序
      this.rightBoShow = !this.rightBoShow;
    },
    //打开添加云盘弹窗
    addCloudDialog (item) {
      // if(item.appName == 'iCloudDrive'){
      //   this.$toast({
      //       text: this.$t('language.addEmail.iCloudNotice'),
      //       type: 'fail',
      //       idValue: "addClouds"
      //   });
      //   return;
      // }
      // if(item.appName == 'iCloudPhotos'){
      //   this.$toast({
      //       text: this.$t('language.addEmail.iCloudPhotosNotice'),
      //       type: 'fail',
      //       idValue: "addClouds"
      //   });
      //   return;
      // }
      if(item.appName == 'gSuite'  || item.appName == 'gSuiteSharedDrive' || item.appName == 'boxBusiness' 
      || item.appName =='dropbox4Business' || item.appName =='oneDrive4Business'){
       this.$refs.addSpecialDialog.specialCloudShow =true;
       this.$refs.addSpecialDialog.cloudInfo = item;
       return;
      }
      if (item.appName == "FTP") {//如果是ftp云盘
        this.$refs.addFtpDialog.ftpDialog = true;
        this.$refs.addCloudDialog.cloudDialog = false;
        this.$refs.addFtpDialog.cloudName = item.appName;
        this.$refs.addFtpDialog.cloudIcon = item.appName;
        this.$refs.addFtpDialog.cloudInfo = item;
      }else if(this.directlyAddCloud.includes(item.appName)){
        let that=this;
        let redirectUrl = commonstate.addCloudRedirectUrl;
        let user=commonUtils.getUser();
        let name=this.$t('language.addCloud.'+item.appName).trim().replace(/\s+/ig, " ");
        let allDrives = Object.assign([], this.$store.getters.getUsersDrives);
        let nameArr=[];
       $.each(allDrives, function (i, item) {
            nameArr.push(item.name);
        });
        commonUtils.includesDriveName(nameArr, name, that);
        let addData = new addCloudUtils.addCloudData(user.id, that.reName, null, null, null, null, null, null, item.appName, null, null, redirectUrl);
        //请求后端数据
        this.Utils.doDrivesRequest("add", addData).then(res => {
         if (res.status == 201) {//打开第三方网页
             var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
             localStorage.setItem(user.id+'driveNum',allDrives.length);//用户的云盘列表长度
             that.Utils.openNewWin(res);
         }else{
             if(res.status == 401){
                  this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "addClouds"
                        });
             }
         }
        });
     } else if (item.appName == "NAS") {//如果是nas
        this.$refs.addNasDialog.nasShow = true;
        this.$refs.addCloudDialog.cloudDialog = false;
        this.$refs.addNasDialog.activeName = 'first';
        let tab1 = this.$refs.addNasDialog.$refs.viaFtp;
        let tab2 = this.$refs.addNasDialog.$refs.viaWebDav;
        this.$refs.addNasDialog.$refs.nasDiv.style.height = 470 + 'Px';
        tab1.advancedShow = false;
        tab1.optional = null;
        tab1.email = null;
        tab1.password = null;
        tab1.path = null;
        tab2.username = null;
        tab2.password = null;
        tab2.path = null;
      } else {//如果是除ftp和nas以外的普通云盘
        // if(item.appName == "iCloudPhotos"){
        //   //获取缓存的标签信息
        //   let appleTipsDialogIsCheck = commonUtils.getActiveTagByStore("appleTipsCheck");
        //   if(!this.$refs.appleTipsDialog.tempCheck&&!appleTipsDialogIsCheck){
        //     //iCloudPhotos启动提示弹窗
        //     this.$refs.appleTipsDialog.initShow(item);
        //     return;
        //   }
        // }
        if(item.appName == "iCloudDrive") {
          //获取缓存的标签信息
          let iCloudDriveTipsIsCheck = commonUtils.getActiveTagByStore("iCloudDriveTipsCheck");
          if(!this.$refs.appleICloudDriveDiaLog.tempCheck&&!iCloudDriveTipsIsCheck){
            //iCloudDrive启动提示弹窗
            this.$refs.appleICloudDriveDiaLog.initShow(item);
            return;
          }
        }
        this.resetAddCloudData();
        this.$refs.addCloudDialog.cloudDialog = true;
        this.$refs.addCloudDialog.cloudInfo = item;
        this.$nextTick(function () {
          addCloudUtils.getContainerHeight(this.$refs.addCloudDialog);
        });
        this.$refs.addCloudDialog.cloudName = item.appName;
        this.$refs.addCloudDialog.tipShow = false;
        this.$refs.addCloudDialog.inputCloudNameValue = this.$t('language.addCloud.' + item.appName);
        this.$refs.addCloudDialog.cloudIcon = item.appName;
      }
    },
    //打开界面重置添加云盘数据
    resetAddCloudData () {
      this.$refs.addCloudDialog.email = '';
      this.$refs.addCloudDialog.password = '';
      this.$refs.addCloudDialog.username = '';
      this.$refs.addCloudDialog.keyID = '';
      this.$refs.addCloudDialog.applicationKey = '';
      this.$refs.addCloudDialog.bucketName = '';
      this.$refs.addCloudDialog.otherServerHttp = '';
      this.$refs.addCloudDialog.appleId = '';
    },//添加云盘界面的取消上传
    cancelUpload: function (data) {
      let that = this;
      if (commonstate.source) {
        commonstate.source.cancel('取消上传' + data);
      }
    },
  },
  computed: {
    //用于对云盘按英文字母进行排序
    reorder: function () {
      return this.allCategories.sort(function (x, y) {
        return x["appName"].localeCompare(y["appName"]);
      });
    },
    sortedClouds() {
      return this.clouds.slice().sort(); 
    },
  }
};
</script>

<style>
@charset "utf-8";
.add-cloud-center{
    display: table-cell;
    vertical-align: middle;
}
.all-drives {
  width: 100%;
  height: 100%;
}
.add-txt{
    position: absolute;
    font-weight:bold;
    top: 15Px;
    left: 15Px;
}
.slide {
  position: relative;
  left: 3px;
  /*no*/
  top: 2px;
  /*no*/
}

.right-cont-middle {
  height: 80px;
  /*no*/
  width: 96%;
  float: left;
  background-color: #f2f7fe;
  padding: 0% 2% 0% 2%;
  position: relative;
}

.right-cont-middle-position {
  height: 20px;
  /*no*/
  width: 96%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.select-box-click {
  border: 1px solid #8a96e3;
  /*no*/
}

.connect-desc {
  float: left;
  font-size: 20px;
  /*no*/
}

.cont-box {
  width: 96%;
  height: 96%;
  margin: 0% 2% 0% 2%;
  box-sizing: border-box;
  overflow: hidden;

}

.cont-box-order{
  width: 96%;
  height: 96%;
  margin: 0% 2% 0% 2%;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  padding:2%;
  border: 1Px solid #e4e9f3;
}

.drive-add-clouds-order {
  width: 100%;
  height: 47.5%;
  text-align: center;
}

.up-clouds-none {
  border: none !important;
}

.drive-add-cloud:hover {
  box-shadow: 1px 1px 5px 1px #bababa;
  /*no*/
}

.sort {
  float: right;
  cursor: pointer;
}

/*云盘添加列表界面*/
.drive-add-cloud {
  width: 11.9%;
  float: left;
  color: rgba(0, 0, 0, 0.6);
  height: 105Px;
}

.drive-add-cloud-order {
  width: 12%;
  float: left;
  color: rgba(0, 0, 0, 0.6);
  height: 105Px;

}

.drive-add-cloud-order:hover {
  box-shadow: 1px 1px 5px 1px #bababa;
  /*no*/
}

.add-cloud-item-name {
  width: 100%;
  height: 20%;
  font-size: 14px;
  /*no*/
  float: left;
  text-align: center;
  margin-top: 5Px;
}

.cloudPosition {
  position: relative;
  top: 5px;
  /*no*/
}

.select-mode-value {
  width: 178px;
  /*no*/
  height: 68px;
  /*no*/
  position: absolute;
  z-index: 1;
  font-size: 14px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid #8a96e3;
  /*no*/
  border-top: none;
  background: #fff;
  left: 130px;
  /*no*/
  top: 44px;
  /*no*/
}

.select-cod-value {
  width: 178px;
  /*no*/
  height: 170px;
  /*no*/
  position: absolute;
  z-index: 1;
  font-size: 14px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid #8a96e3;
  /*no*/
  border-top: none;
  background: #fff;
  left: 130px;
  /*no*/
  top: 44px;
  /*no*/
}

.lite_cloud {
  width: 158px;
  height: 98px;
  float: left;
  margin-right: 8px;
  margin-bottom: 20px;
  border-radius: 5px;
  cursor: pointer;
}
.lite_cloud:hover {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.lite_cloud>div {
  width: 60px;
  height: 60px;
  margin: 5px auto;
}
.lite_cloud>span {
  color: #333;
}

.drive-add-clouds-down {
  padding-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/add_cloud.vue